// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2C6GR","col":"styles_col__1efhR","fulfillmentStatus":"styles_fulfillmentStatus__1P-aM","emailCol":"styles_emailCol__1l43N"};